import Base from '../../components/base/base';
import { onReady } from '../../shared/utils/helpers';
import TextLineFadeOnScroll from '../../components/text-line-fade-on-scroll/text-line-fade-on-scroll';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import './sixteen-nineteen.scss';

gsap.registerPlugin(ScrollTrigger);

export default class SixteenNineteenPage extends Base {
  constructor(debug = false) {
    super(debug);
    this.init();
  }

  init(): void {
    this.log('Sixteen Nineteen page initialized');

    new TextLineFadeOnScroll({
      debug: this.debug
    });

    this.initWatermarkFade();
  }

  private initWatermarkFade(): void {
    const watermark = document.querySelector<HTMLElement>('._1619-pause-section ._1619-watermark');

    if (!watermark) {
      this.log('Watermark not found for fade animation.');
      return;
    }

    gsap.set(watermark, { opacity: 0 });

    gsap.to(watermark, {
      opacity: 1,
      duration: 1.8,
      ease: 'power2.out',
      scrollTrigger: {
        trigger: watermark,
        start: 'top 66%',
        toggleActions: 'play none none none',
        once: true
      }
    });
  }
}

onReady(() => {
  new SixteenNineteenPage(true);
});
